import { Button } from "antd";
import { useHistory } from "react-router-dom";
import { Locale } from "../../../utils";

const i18n = Locale.getInstance();
const ShopSliderAdListHeader = () => {
  const history = useHistory();
  return (
    <div className="header">
      <div className="actions">
        <Button
          onClick={() => {
            history.push({
              pathname: "/main/shop/slider-ads/edit",
            });
          }}
          type="primary"
        >
          {i18n.t("tuangou.sliderAd.add")}
        </Button>
      </div>
    </div>
  );
};
export default ShopSliderAdListHeader;
